export const environment = {
  production: true,
  version: '44b826f20e',
  site_version: 'SITE_VERSION'
};
